import { http } from 'services/http';
import { TRIP_GET_ONE, TRIP_TASKS_GET_MANY } from 'api/query-keys.ts';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IDeleteTripTaskVariables {
  tripId: number;
  tripTaskId: number;
}

export const useDeleteTripTask = () => {
  return useMutationBase<unknown, unknown, IDeleteTripTaskVariables>({
    mutationFn: async (variables) => {
      const { tripId, tripTaskId } = variables;
      await http.delete(`/v1/trips/${tripId}/trip-tasks/${tripTaskId}`);
    },

    invalidateCallback: (_, { tripId }) => [
      [TRIP_TASKS_GET_MANY, tripId],
      [TRIP_GET_ONE, tripId],
    ],
  });
};
